// Justificativa SOX do reset do onboarding do Workflow (tela Clientes → aba Workflow SOX).

/** Escapa texto para ser colocado dentro de HTML (a janela do SweetAlert recebe HTML). */
export const escaparHtml = (texto: string): string =>
  texto
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

/** Texto sugerido para a justificativa; a pessoa pode editar antes de confirmar. */
export const justificativaPadraoReset = (nomeCliente: string): string =>
  `Reset da configuração do Workflow SOX solicitado pela equipe interna para reiniciar o onboarding do cliente ${nomeCliente}. ` +
  'As configurações serão refeitas do zero e o histórico de auditoria SOX é preservado.';

/** O que o reset realmente alterou (vem do backend). */
export interface ResetOnboardingResultado {
  empresasAfetadas: number;
  conciliacoesCanceladas: number;
  acessosRemovidos: number;
  responsabilidadesRemovidas: number;
  mapeamentosDeParaRemovidos: number;
  etapasZeradas: boolean;
}

/** Linhas do resumo mostrado depois do reset (só o que de fato mudou, com os números reais). */
export const resumoDoReset = (r?: ResetOnboardingResultado | null): string[] => {
  if (!r) return [];
  const linhas: string[] = [];
  if (r.etapasZeradas) linhas.push('5 etapas do onboarding zeradas');
  if (r.empresasAfetadas > 0) linhas.push(`${r.empresasAfetadas} empresa(s) do cliente afetada(s)`);
  if (r.conciliacoesCanceladas > 0) linhas.push(`${r.conciliacoesCanceladas} conciliação(ões) cancelada(s)`);
  if (r.acessosRemovidos > 0) linhas.push(`${r.acessosRemovidos} acesso(s) usuário × empresa removido(s)`);
  if (r.responsabilidadesRemovidas > 0) linhas.push(`${r.responsabilidadesRemovidas} responsabilidade(s) da matriz removida(s)`);
  if (r.mapeamentosDeParaRemovidos > 0) linhas.push(`${r.mapeamentosDeParaRemovidos} vínculo(s) De/Para removido(s)`);
  return linhas;
};
